/* eslint-disable */
import React from 'react';

import {
  baseDateFormat,
  baseDateFormatting,
  baseTimeFormatting,
} from '../../../../../../../common/helper';

import { useTranslate } from '../../../../../../../hooks';

import './editShiftSwap.css';

import { SwapShiftConfirmationType } from '../../types';

import CloseIcon from '@mui/icons-material/Close';
import { EmpNameCard } from '../../swap-shift/components';
import { DateField, Button } from '../../../../../../../components';

export function SwapShiftConfirmation({
  data,
  toggleModal,
  onConfirm,
}: SwapShiftConfirmationType) {
  const { translate } = useTranslate();

  return (
    <div className="swap-conf-container base-modal">
      <div className="swap-conf-title-sec">
        <p className="swap-conf-title-sec-text">
          {baseDateFormat(data?.date, baseDateFormatting)}
        </p>
        <div className="swap-conf-title-sec-close" onClick={toggleModal}>
          <CloseIcon style={{ color: '#9CA3AF' }} />
        </div>
      </div>
      <div className="swap-conf-body-sec">
        <EmpNameCard
          empName={data?.employee?.name}
          designation={data?.employee?.department}
          profilePic={data?.employee?.profilePic}
        />
        <table className="emp-card-table">
          <thead className="emp-card-table-thead">
            <tr className="emp-card-table-head-row">
              <th className="emp-card-table-th" align="center">
                <p className="emp-card-table-th-txt">{translate('Time')}</p>
              </th>
              <th className="emp-card-table-th" align="center">
                <p className="emp-card-table-th-txt">{translate('Shift')}</p>
              </th>
              <th className="emp-card-table-th" align="center">
                <p className="emp-card-table-th-txt">{translate('Timezone')}</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="emp-card-time-cell" align="center">
                <div className="emp-card-time-container">
                  {data?.isWeekOff ? (
                    <span className="font-week-off">
                      {translate('Week Off')}
                    </span>
                  ) : (
                    <>
                      {data?.startTime ? (
                        <DateField
                          value={data?.startTime}
                          offset={data?.timezone?.offset}
                          format={baseTimeFormatting}
                        />
                      ) : (
                        '-'
                      )}
                      &nbsp; -&nbsp;
                      {data?.endTime ? (
                        <DateField
                          value={data?.endTime}
                          offset={data?.timezone?.offset}
                          format={baseTimeFormatting}
                        />
                      ) : (
                        '-'
                      )}
                    </>
                  )}
                </div>
              </td>
              <td className="emp-card-timezone" align="center">
                <p
                  className={`emp-card-table-txt ${
                    data?.isToday && 'font-success'
                  }`}
                >
                  {data?.code || data?.shift?.code}
                </p>
              </td>
              <td className="emp-card-table-txt">
                {data?.timezone?.name ?? '-'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="swap-conf-body-action-sec">
        <Button
          className="outline-btn global-btn swap-conf-cancel-btn"
          onClick={toggleModal}
        >
          {translate('Cancel')}
        </Button>
        <Button
          className="primary-btn global-btn swap-conf-save-btn"
          onClick={onConfirm}
        >
          {translate('Swap Shift')}
        </Button>
      </div>
    </div>
  );
}
